import * as React from "react";
import { Plus, UserPlus, FileText, type LucideIcon } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

import seedData from "../../../../seed-data.json";

const iconMap: Record<string, LucideIcon> = {
  plus: Plus,
  "user-plus": UserPlus,
  "file-text": FileText,
};

interface QuickAction {
  id: string;
  label?: string;
  icon: string;
  action: string;
}

/**
 * QuickActions - Action buttons
 *
 * Features:
 * - Primary and secondary action buttons
 * - i18n: labels resolved via useTranslation('dashboard')
 */
export function QuickActions() {
  const { t } = useTranslation("dashboard");
  const actions = seedData.dashboard.quickActions as QuickAction[];

  const handleAction = (action: string) => {
    switch (action) {
      case "createProject":
        toast.info("Create project feature coming soon");
        break;
      case "inviteMember":
        toast.info("Invite member feature coming soon");
        break;
      case "createReport":
        toast.info("Create report feature coming soon");
        break;
      default:
        toast.info(`${action} feature coming soon`);
    }
  };

  return (
    <div className="space-y-3">
      <h3 className="text-sm font-medium text-muted-foreground">Quick Actions</h3>
      <div className="flex flex-wrap gap-3">
        {actions.map((action, index) => {
          const Icon = iconMap[action.icon] || Plus;
          const isPrimary = index === 0;

          return (
            <Button
              key={action.id}
              variant={isPrimary ? "default" : "outline"}
              onClick={() => handleAction(action.action)}
            >
              <Icon className="mr-2 h-4 w-4" />
              {t(`quickActions.${action.id}`)}
            </Button>
          );
        })}
      </div>
    </div>
  );
}

export default QuickActions;
